<template>
  <b-card no-body class="mt-n2">
    <b-row class="mx-1 mt-2 mb-1">
      <b-col cols="6">
        <h4>{{ selectionHeader }}</h4>
      </b-col>
      <b-col cols="12">
        <div v-if="hasServerSelection">
          <b>Hostname(s)</b> : {{ hostnameFormatter(selectedServer.ip, ',', ', ') }}
        </div>
      </b-col>
    </b-row>
    <div v-if="this.hasServerSelection" class="mx-1 mb-1">
      <b-row>
        <IpTrafficDetails
          :timeRange="timeRange"
          :role="selectedRole"
          :selectedServer="selectedServer"
          :serviceType="serviceType"
        >
        </IpTrafficDetails>
      </b-row>
    </div>
    <b-row>
      <DnsDetails :url="this.dnsSmartSamplerUrl"></DnsDetails>
    </b-row>
    <b-row>
      <ThreatDetails :serviceType="serviceType"></ThreatDetails>
    </b-row>
  </b-card>
</template>

<script>
import IpTrafficDetails from '@/xvisor/components/security/IpTrafficDetails.vue';
import SecurityEventBus from '@/xvisor/bus/SecurityEventBus';
import ThreatDetails from '@/xvisor/components/security/ThreatDetails.vue';
import DnsDetails from '@/xvisor/components/security/DnsDetails.vue';
import hostnameFormatter from '@/xvisor/utilities/hostnameFormatter';
import threatRole from '@/xvisor/constants/threatRole';

export default {
  props: {
    timeRange: {
      type: Object,
      required: true,
    },
    serviceType: {
      type: String,
      required: true,
    },
  },
  components: {
    IpTrafficDetails,
    ThreatDetails,
    DnsDetails,
  },
  data() {
    return {
      selectedServer: null,
      selectedRole: threatRole.client.value,
      tsData: [],
      loaded: false,
    };
  },
  created() {
    SecurityEventBus.$on('update-selected-server', (server) => {
      this.selectedServer = server;
    });
    SecurityEventBus.$on('update-selected-role', (role) => {
      this.selectedServer = null;
      this.selectedRole = role;
    });
  },
  computed: {
    selectionHeader() {
      if (!this.hasServerSelection) return 'No Address Selected';
      return `Traffic Details for ${this.selectedServer.ip}`;
    },
    hasServerSelection() {
      return this.selectedServer !== null && this.selectedServer !== undefined;
    },
    selectedServerIp() {
      if (!this.hasServerSelection) return '';
      return this.selectedServer.ip;
    },
  },
  watch: {
    timeRange() {
      this.selectedServer = null;
    },
  },
  methods: {
    hostnameFormatter,
  },
};
</script>
